import Lib from "../../../commons/lib";

export default class Service {
  static idopontUrl = window.location.origin + "/api/idopont/";

  static partnerUrl = window.location.origin + '/api/partner/';

  static listHelyszin(fnDone) {
    Lib.MicroServices.requestService([{
          method: "GET",
          url: Service.idopontUrl + "public/inithelyszin",
          args: { requestType: "idopont-listbyrole-get" },
        }], fnDone);
  }

  static listSzolgaltatasByHelyszin(helyszinid, fnDone) {
    Lib.MicroServices.requestService([{
          method: "GET",
          url: Service.idopontUrl + "public/initszolgaltatas",
          args: { requestType: "public-initszolgaltatas-get" },
          params: {
            helyszinid
          }
        }], fnDone);
  }

  static listNaptarNezet(kezdet, helyszinid, szolgaltatasid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'public/naptar',
      args: { requestType: 'public-naptar-get' },
      params: {
        kezdet, helyszinid, szolgaltatasid
      }
    }], fnDone);
  }

  static listNaptarDays(helyszinid, szolgaltatasid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'public/listpublicnaptardays',
      args: { requestType: 'public-listpublicnaptardays-get' },
      params: {
        helyszinid, szolgaltatasid
      }
    }], fnDone);
  }

  static customDolgozo(szolgaltatasid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'public/customdolgozo',
      args: { requestType: 'public-customdolgozo-get' },
      params: {
        szolgaltatasid
      }
    }], fnDone);
  }

  static initFoglalas(kezdet, helyszinid, szolgaltatasid, dolgozoid, getdolgozo, getblock, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'public/initfoglalas',
      args: { requestType: 'public-initfoglalas-get' },
      params: {
        kezdet, helyszinid, szolgaltatasid, dolgozoid, getdolgozo, getblock
      }
    }], fnDone);
  }

  static addFoglalas(foglalas, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.idopontUrl + 'public/insertfoglalas',
      args: { requestType: 'public-insertfoglalas-post' },
      data: foglalas
    }], fnDone);
  }

  static activateFoglalas(sha, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.idopontUrl + 'public/activatefoglalas',
      args: { requestType: 'public-activatefoglalas-get' },
      params: {
        sha
      }
    }], fnDone);
  }

  // PARTNER START

  static listTelefonEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.partnerUrl + 'partner/telefonenum',
      args: { requestType: 'partner-telefonenum-list' }
    }], fnDone);
  }

  // PARTNER END

}
